import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { getSearchAgentResults } from '@redux/selectors/AgentSelector';
import {
  agentLookup,
  setAgentLookup,
} from '@redux/modules/agent';
import { getImpersonationData } from '@redux/modules/impersonation';

import AgentLookupTable from '@components/table/AgentLookupTable';
import AgentSearchForm from '@components/form/forms/AgentSearchForm';
import Card from '@components/smartAdminUI/Card';
import Modal from '@components/smartAdminUI/Modal';

const AgentLookupModal = ({
  id = 'agentLookupModal',
  onChange = input => input,
  getCurrentImpersonationData = false,
}) => {
  const dispatch = useDispatch();
  const searchAgentResults = useSelector(getSearchAgentResults);

  const agentSelected = row => {
    const jsonBody = {
      action: 'select',
      where: {
        clause: [
          {
            name: 'UniqueID',
            value: row.UniqueID,
          },
        ],
      },
    };
    onChange(row);
    dispatch(setAgentLookup(jsonBody))
      .then(() => {
        if (getCurrentImpersonationData) dispatch(getImpersonationData());
      });
  };

  const onSubmitClicked = jsonBody => {
    dispatch(agentLookup(jsonBody));
  };

  return (
    <Modal
      id={id}
      modalHeader="Agent Lookup"
      position="center"
      size="lg"
    >
      {searchAgentResults && (
        <Card id="agentsLookupTable">
          <AgentLookupTable
            displayData={searchAgentResults}
            onAgentSelect={agentSelected}
            isModal
          />
        </Card>
      )}
      <Card id="agentsLookupForm">
        <AgentSearchForm
          onSubmitClicked={onSubmitClicked}
        />
      </Card>
    </Modal>
  );
};

AgentLookupModal.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  getCurrentImpersonationData: PropTypes.bool,
};

export default AgentLookupModal;
